export default [{
  path: '/set',
  component: resolve => require(['@/page/set/index'], resolve),
  children: [
    // 概况
    {
      path: '/',
      name: 'SetBase',
      component: resolve => require(['@/page/set/base'], resolve)
    },
    // 楼号－管理
    {
      path: '/set/louhao',
      name: 'SetLouhao',
      component: resolve => require(['@/page/set/louhao'], resolve)
    },
    // 单元－管理
    {
      path: '/set/danyuan',
      name: 'SetDanyuan',
      component: resolve => require(['@/page/set/danyuan'], resolve)
    },
    // 户型－管理
    {
      path: '/set/huxing',
      name: 'SetHuxing',
      component: resolve => require(['@/page/set/huxing'], resolve)
    },
    // 相册－管理
    {
      path: '/set/xiangce',
      name: 'SetXiangce',
      component: resolve => require(['@/page/set/xiangce'], resolve)
    },
    // 房号－管理
    {
      path: '/set/fanghao',
      name: 'SetFanghao',
      component: resolve => require(['@/page/set/fanghao'], resolve)
    },
    // 房号－编辑
    {
      path: '/set/fanghao/edit',
      name: 'SetFanghaoEdit',
      component: resolve => require(['@/page/set/fanghao_edit'], resolve)
    },
    // 分销－设置
    {
      path: '/set/fenxiao',
      name: 'SetFenxiao',
      component: resolve => require(['@/page/set/fenxiao'], resolve)
    },
    // 营销－设置
    {
      path: '/set/yingxiao',
      name: 'SetYingxiao',
      component: resolve => require(['@/page/set/yingxiao'], resolve)
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/router/set.js